var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l(([1, 2, 3, 4]),function(r){return _c('v-card',{key:r,staticClass:"mb-3 mx-5"},[_c('v-skeleton-loader',{attrs:{"type":"article"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }